<template>
  <div>
    <div class="dform_head">
      <div class="dform_head_l">
        <div class="dform_head_title_befor"></div>
        <div class="dform_head_title">生源信息</div>
      </div>
      <!-- <div class="dform_head_r">
        <div v-if="studentData.audit_status == 0" class="dform_head_more">生源待完善</div>
        <div v-if="studentData.audit_status == 1" class="dform_head_more">生源待审核</div>
        <div v-if="studentData.audit_status == 2" class="dform_head_more">生源已审核</div>
        <div v-if="studentData.audit_status == 1" class="dform_head_more_after" @click="toAuditStudent">审核>>></div>
      </div> -->
    </div>
    <dformVue
      v-if="showTalent"
      :formconfig="schema"
      :data="dataTalent"
    ></dformVue>
  </div>
  <div>
    <div class="dform_head">
      <div class="dform_head_l">
        <div class="dform_head_title_befor"></div>
        <div class="dform_head_title">签约信息</div>
      </div>
    </div>
    <dformVue class="step2" :formconfig="signForm" :data="dataSign"></dformVue>
    <div class="btn-wrap">
      <p class="statewords">{{ isShowNOPass }}</p>
    </div>
    <div class="btn-wrap">
      <el-button type="primary" @click="amend()">修改</el-button>
    </div>
  </div>
</template>
      <script lang="ts">
import { defineComponent, provide, reactive, ref, toRefs } from "vue";
import { formschema, FormItem, fileditem } from "../form/dataform";
import dformVue from "../components/collegeform.vue";
import { getForm } from "../form/Forms";
import { FormValidators } from "../form/FormValidators";
import { ElMessage } from "element-plus";
import Api from "@/http/Api";
import { StorgeUtils } from "@/utils/StorageUtils";
import { useStore } from "vuex";
import { key } from "@/state/store";
import { useRoute } from 'vue-router';
import router from "@/router/router";
import { majorRelatedPositionLoadForm } from "@/utils/addOn";

export default defineComponent({
  name: "collegeAmendSign",
  components: {
    dformVue,
  },
  setup() {
    let currentState
    const route = useRoute()
    const store = useStore(key);
    const schema = reactive(new Array<formschema>());
    const selfTalentFieldlist = ref<string>("");
    const signForm = reactive(new Array<formschema>());
    const dataTalent = reactive(new Map<string, any>());
    const dataSign = reactive(new Map<string, any>());
    const showTalent = ref<boolean>(false);
    const showSign = ref<boolean>(false);
    const selfDepartmentFieldList = ref<string>(""); // 自定义签约部分表单
    const recordid = ref<string>("");
    const signModePopup = ref<boolean>(true);
    const signTipsPopup = ref<boolean>(false);
    const checkerror = ref(new Array<string>());
    const isShowNOPass = ref<string>(""); // 原因
    const isReset = ref<boolean>(false); // 重新审核按钮
    const pass = ref<boolean>(false); // 通过按钮
    const errorshow = ref<boolean>(false); // 弹框显示隐藏
    const signMode = ref<number>(0);
    const year = ref<string>("");
    const gollegeinfo = reactive({
      page: "collegeAmendSign",
      time: '',
    });
    const signParams = reactive({
      talent_info: {},
      department_info: {},
      profile_address: {},
      talent_info_self_field_list: Array<fileditem>(),
      department_info_self_field_list: Array<fileditem>(),
    });
    const studentData = reactive({
      audit_status:null,
      studentid:'',
    })
    const extractHash = (url) => {
      const hashIndex = url.indexOf('#');
      if (hashIndex !== -1) {
        return url.slice(hashIndex + 1);
      }
      return '';
    }
    const getRecordidFromUrl = () => {
      let url = extractHash(window.location.href);
      let querys = url.substring(url.indexOf("?") + 1).split("&");
      let result: any[] = [];
      for (let i = 0; i < querys.length; i++) {
        let temp = querys[i].split("=");
        console.log(temp);
        if (temp.length < 2) {
          result[temp[0]] = "";
        } else {
          result[temp[0]] = temp[1];
        }
      }
      recordid.value = result['recordid'];
      let tempToken = result["token"];
      let tempAccountid = result["accountid"];
      let userType = result["usertype"];
      gollegeinfo.time = result["t"]
      //token accountid usertype 小程序传参
      if(tempToken){
        StorgeUtils.set('token',tempToken);
      }
      if(tempAccountid){
        StorgeUtils.set("accountid",tempAccountid);
      }
      if(userType){
        StorgeUtils.set("usertype",userType);
      }
    };
    getRecordidFromUrl();

    //使用表单名称载入对应表单
    const LoadExtForm = (formname: string, formschema: any) => {
      const form = getForm(formname);
      if (form) {
        formschema = formschema.push(form);
      }
    };
    //调用接口加载表单 根据类型就业类别加载
    const loadExtFormByHttp = (employmentType: string) => {
      Api.collegeSignInfoForm(year.value, employmentType).then((res) => {
        if (res.status) {
          const formName = `sign_${res.data.employment_type}`;
          const index = signForm.findIndex((item) => item.name == formName);
          let signSelfList = res.data.self_field_list;
          //debugger;
          if (index) {
            for (let item of res.data.field_list) {
              let location = signForm[index].data.length - 1;
              signForm[index].data.splice(location, 0, item);
            }
            //signForm[index].data.unshift()
            //console.log(signForm[index].data)
            if (signSelfList && signSelfList.length > 0) {
              for (let item of res.signSelfList) {
                let location = signForm[index].data.length - 1;
                signForm[index].data.splice(location, 0, item);
              }
              selfDepartmentFieldList.value = JSON.stringify(signSelfList);
            }
          }
          showSign.value = true;
        }
        //console.log(res);
        console.log(signForm);
      });
    };
    //卸载表单名称以后加载的表单
    const UnloadExtFormAfter = (formname: string, formschema: any) => {
      const index = formschema.findIndex((item) => item.name == formname);
      console.log(index);
      if (index > -1) {
        formschema.splice(index, 1);
      }
    };

    //清空签约表单值  在切换就业类别时
    const emptySignData = (except:Array<string>=[]) => {
      dataSign.forEach((value, key) => {
        if(!except.includes(key)){
          dataSign.set(key, undefined);
        }
      });
    };

    //选择就业类别
    provide("signForm", signForm);
    provide("signModePopup", signModePopup);
    provide("LoadExtFrom", LoadExtForm);
    provide("UnloadExtFormAfter", UnloadExtFormAfter);
    provide("emptySignData", emptySignData);
    provide("loadExtFormByHttp", loadExtFormByHttp);
    provide("signMode", signMode);
    //获取签约表单相关信息

    Api.collegeSignUp(recordid.value).then((res) => {
      console.log("修改表单", res);
      StorgeUtils.set("year", res.data.year);
      StorgeUtils.set("collegeid", res.data.collegeid);
      StorgeUtils.set("facultyid", res.data.facultyid);

      // 生源表单
      let fieldData = res.data.talent_field.field_data;
      let selfFieldData = res.data.talent_field.self_field_data;
      let fieldList = res.data.talent_field.field_list;
      let selfFileList = res.data.talent_field.self_field_list;
      selfTalentFieldlist.value = JSON.stringify(
        res.data.talent_field.self_field_list
      );
      for (let key in fieldData) {
        //console.log(key,obj[key]);
        dataTalent.set(key, fieldData[key]);
      }
      for (let key in selfFieldData) {
        //console.log(key,obj[key]);
        dataTalent.set(key, selfFieldData[key]);
      }
      LoadExtForm("student_source", schema);
      showTalent.value = true;

      if (fieldList.length > 0) {
        for (let item of fieldList) {
          schema[0].data.push(item);
        }
      }

      if (selfFileList.length > 0) {
        for (let item of selfFileList) {
          schema[0].data.push(item);
        }
        selfTalentFieldlist.value = JSON.stringify(
          res.data.talent_field.self_field_list
        );
      }
      if (res.data.department_field) {
        store.commit(
          "employmentTypeChange",
          res.data.department_field.employment_type
        );
      }
      //   for (let item of schema[0].data) {
      //     item.is_disable = true;
      //   }

      // 签约表单
      currentState = res.data.request_state.current_state
      let signData = res.data.department_field?.field_data;
      let signFieldData = res.data.department_field?.field_list;
      let signSelfList = res.data.department_field?.self_field_list;
      let signSelfListData = res.data.department_field?.self_field_data;
      let archivesFieldData = res.data.archives_field?.field_data;
      let archivesFieldList = res.data.archives_field?.field_list;
      studentData.audit_status = res.data.student_data.audit_status
      studentData.studentid = res.data.student_data.studentid
      const formName = `sign_${res.data.department_field.employment_type}`;
      const formStatusName =`sign_status_${res.data.department_field.employment_status ||  res.data.department_field.field_data.employment_status}`
      store.commit("fieldRemarkChange",res.data?.department_field?.required_field_remark);
      store.commit(
        "employmentStatusChange",
        res.data.department_field.employment_status ||  res.data.department_field.field_data.employment_status
      );
      //处理表单的值 值处理完后再加载表单 否则值会未绑定
      for (let key in signData) {
        //console.log(key,obj[key]);
        dataSign.set(key, signData[key]);
      }
      for (let key in signSelfListData) {
        dataSign.set(key, signSelfListData[key]);
      }
      for (let key in archivesFieldData) {
        dataSign.set(key, archivesFieldData[key]);
      }
      // LoadExtForm("student_source", schema);
      LoadExtForm("sign_base", signForm);
      LoadExtForm(formStatusName, signForm);
      LoadExtForm(formName, signForm);
      const index = signForm.findIndex((item) => item.name == formName);
      console.log(index);
      if (index) {
        let signFormData = signForm[index].data
        console.log(signFieldData);
        for (let item of signFieldData) {
          let location = signForm[index].data.length - 1;
          signForm[index].data.splice(location, 0, item);
        }
        console.log(signForm[index]);
        if (signSelfList && signSelfList.length > 0) {
          for (let item of signSelfList) {
            let location = signForm[index].data.length - 1;
            signForm[index].data.splice(location, 0, item);
          }
          selfDepartmentFieldList.value = JSON.stringify(signSelfList);
        }
        if(archivesFieldList && archivesFieldList.length > 0 && Object.values(archivesFieldData).join('')){
          for (let item of archivesFieldList) {
            item.is_disable = true
            item.required = false
            let location = signForm[index].data.length - 1;
            signForm[index].data.splice(location, 0, item);
          }
        }
        signFormData.push(signFormData.splice(signFormData.findIndex(v=>v.field==='business_license'),1).pop() as any)
        signFormData.push(signFormData.splice(signFormData.findIndex(v=>v.field==='protocol_photos'),1).pop() as any)
        majorRelatedPositionLoadForm(signFormData, res.data)
      }
      signForm.forEach((form) => {
        form.data.forEach((item) => {
          if (item.field == "employment_type"||item.field == "employment_status") {
            item.is_disable = true;
          // }else if(res.data.sign_mode == 2 && ["employerment_agreement_number"].includes(item.field)){
          //   // 协议书打印签约的就业协议书编号不可修改
          //   item.is_disable = true;
          }
        });
      });

      console.log(dataSign, 22222);
      //ata = res.talent_field.field_data;
    });
    const GetData = (form: any, data: any) => {
      //过滤不在表单堆栈中的值
      let fields = new Map<string, undefined>();
      //生成表单字段表
      //console.log(form);
      form.forEach((form) => {
        form.data.forEach((item) => {
          fields.set(item.field, undefined);
        });
      });
      console.log(fields);
      //检查data是否在表单字段中
      let retdata = new Map<string, any>();
      data.forEach((value, key) => {
        if (fields.has(key)) retdata.set(key, value);
      });

      console.log(retdata);
      return retdata;
    };

    // 格式化表单处理
    const formatSignParams = () => {
      let talentInfo: Map<string, any> = GetData(schema, dataTalent);
      let formData: Map<string, any> = GetData(signForm, dataSign);
      console.log(talentInfo, formData);

      talentInfo.forEach((value, key) => {
        signParams.talent_info[key] = value;
      });
      formData.forEach((value, key) => {
        signParams.department_info[key] = value;
      });
      if (selfTalentFieldlist.value) {
        let list = JSON.parse(selfTalentFieldlist.value);
        signParams.talent_info_self_field_list = []
        for (let item of list) {
          signParams.talent_info_self_field_list.push({
            field: item.field,
            value: talentInfo.get(item.field),
          });
        }
      }
      if (selfDepartmentFieldList.value) {
        let list = JSON.parse(selfDepartmentFieldList.value);
        signParams.department_info_self_field_list = []
        for (let item of list) {
          signParams.department_info_self_field_list.push({
            field: item.field,
            value: formData.get(item.field),
          });
        }
      }
    };
    // 修改
    const amend = async () => {
      console.log(55555555)
      let talentInfo: Map<string, any> = GetData(schema, dataTalent);
      let formData: Map<string, any> = GetData(signForm, dataSign);
      const rules: FormItem[] = [];
      schema.forEach((form) => {
        form.data.forEach((item) => {
          rules.push(item);
        });
      });
      signForm.forEach((form) => {
        form.data.forEach((item) => {
          rules.push(item);
        });
      });
      const result = await FormValidators.checkForm(rules,new Map([...talentInfo,...formData]), ['business_license']);
      if (result) {
        formatSignParams();
        console.log(signParams);
        let fnStr = 'collegeAmendSign'
        if(currentState === 2) {
          fnStr = 'collegeUpdateDoneSign'
        }
        Api[fnStr](recordid.value, signParams).then((res) => {
          console.log(res);
          if (res.status) {
            ElMessage({
              message: "修改成功",
              type: "success",
              offset: 50,
            });
            if(route.query?.back){
              router.back()
            }else{
              let obj = JSON.parse(JSON.stringify(gollegeinfo));
              window.parent.postMessage(obj, "*");
            }
          }
        });
      }
    };
    const toAuditStudent= ()=>{
      let obj = JSON.parse(JSON.stringify(gollegeinfo));
      obj.type = 'toAuditStudent'
      obj.studentid = studentData.studentid
      window.parent.postMessage(obj, "*");
    }

    return {
      schema,
      signForm,
      showTalent,
      showSign,
      dataTalent,
      dataSign,
      GetData,
      amend,
      signModePopup,
      signTipsPopup,
      checkerror,
      isShowNOPass,
      isReset,
      errorshow,
      pass,
      studentData,
      toAuditStudent,
    };
  },
  computed: {},
});
</script>
<style scoped>
  .btn-wrap {
    height: 60px;
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .err-text {
    text-align: center;
    margin: 10px 0;
    font-size: 14px;
    font-family: 微软雅黑;
    color: black;
  }
  .sign-select .sign-type img {
    width: 60px;
    height: 60px;
  }
  .sign-select .sign-type div {
    font-size: 12px;
    color: #cccccc;
  }
  .statewords {
    color: red;
    font-size: 16px;
    font-family: 微软雅黑;
  }
</style>